<template>
  <el-container>
    <el-header style="height:50px;">
      <div class="common-header-left">
        <div class="common-header-logo">
          <img :alt="3" :src="logoImg_url">
          <label>{{ supplier_name }}</label>
        </div>
        <div class="common-header-title">{{ title }}</div>
      </div>
      <div class="common-header-right">
        <router-link to="/login">返回登录</router-link>
      </div>
    </el-header>
    <el-main>
      <div class="common-container">
        <h2 class="common-title">{{ title }}</h2>
        <div class="common-main el-card">
          <slot></slot>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import IndexApi from '@/api/index.js';
import logoImg from '@/assets/logo.png';

export default {
  data() {
    return {
      /*系统名称*/
      supplier_name: '',
      logoImg_url: '',
    }
  },
  props: {
    title: {type: String, default: ""}
  },
  created() {
    this.getData();
  },
  methods: {
    /*获取基础配置*/
    getData() {
      let self = this;
      self.logoImg_url = logoImg
      IndexApi.base(true)
        .then(res => {
          self.loading = false;
          self.supplier_name = res.data.supplierName;
          if (res.data.supplierbgImg != '' && res.data.supplierbgImg != null) {
            self.bgImg_url = res.data.supplierbgImg;
          } else {
            self.bgImg_url = bgImg;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/login/components/commonPage.vue